<template>
    <Head title="Liste des clients" />

    <AppLayout>
        <div x-data="handleSelect">
            <Datatables>
                <template #title>
                    Liste des clients
                    <span class="font-medium">({{ users.total }})</span>
                </template>
    
                <template #headerButtons>
                    <div class="grid grid-flow-col sm:auto-cols-max sm:justify-end gap-2">
                        <button class="rounded-md py-1 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white"
                            @click="showSearchModal" title="Rechercher"
                        ><i class="fad fa-search"></i>
                        </button>
                        <a :href="route('users.export')" title="Exporter en Excel"
                            class="rounded-md py-1 px-2 bg-white text-greendack hover:bg-greendack-400 hover:text-white inline-flex items-center"
                        >
                            <i class="fa fa-file-excel"></i>
                            <span class="text-xs ml-1 hidden sm:inline">Excel</span>
                        </a>
                    </div>
                </template>
    
                <template #tableHeader>
                    <th width="3%">#</th>
                    <th width="11%">Code</th>
                    <th width="11%">Nom & prénom(s)</th>
                    <th width="13%">Adresse mail</th>
                    <th width="13%">Téléphone</th>
                    <th width="6%"># Colis</th>
                    <th width="7%"># Articles</th>
                    <th width="3%">&nbsp;</th>
                </template>
    
                <template #tableBody>
                    <tr v-for="(user, index) in users.data" :key="user.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ user.code }}</td>
                        <td class="flex items-center">
                            <div class="shrink-0 flex items-center justify-center bg-gray-700 rounded-full mr-2">
                                <img class="w-10 h-10 rounded-full border-2 border-white box-content" :src="user.profile_photo_url">
                            </div>
                            {{ user.name }}
                        </td>
                        <td>{{ user.email ? user.email : 'Non renseigné' }}</td>
                        <td>{{ user.full_phone }}</td>
                        <td>{{ user.packages_count }}</td>
                        <td>{{ user.items_count }}</td>
                        <td>
                            <Link class="flex justify-end" title="Détails" :href="route('users.show', user)">
                                <svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                                    <path class="fill-current text-sky" d="M8.07 16H10V8H8.07a8 8 0 110 8z"></path>
                                    <path class="fill-current text-sky-300" d="M15 12L8 6v5H0v2h8v5z"></path>
                                </svg>
                            </Link>
                        </td>
                    </tr>
                </template>
            </Datatables>
        </div>

        <Pagination :links="users.links" />

        <JetDialogModal :show="searchModal" @close="closeSearchModal" max-width="xl">
            <template #title>Recherche un client</template>

            <template #content>
                <GlobalFilter @search-launched="closeSearchModal" />
            </template>
        </JetDialogModal>
    </AppLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetLabel from '@/Jetstream/Label'
    import JetInput from '@/Jetstream/Input'
    import BotiButton from '@/Components/Button'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import Datatables from '@/Components/Datatables'
    import Pagination from '@/Components/Pagination'
    import JetInputError from '@/Jetstream/InputError'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import GlobalFilter from '@/Components/GlobalFilter'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import RebuildPhoneMixins from '@/Mixins/RebuildPhoneMixins'

    export default defineComponent({
        components: {
            Link,
            Head,
            JetLabel,
            JetInput,
            AppLayout,
            Datatables,
            Pagination,
            BotiButton,
            GlobalFilter,
            JetInputError,
            JetDialogModal
        },

        mixins: [RebuildPhoneMixins],

        props: {
            users: Object,
            roles: Object
        },

        data() {
            return {
                manageModal: false,
                searchModal: false,
                form: this.$inertia.form({
                    name: null,
                    email: null,
                    phone: null,
                    dial_code: null,
                    country_code: null,
                    role: null,
                }),
            }
        },

        methods: {
            closeModal() {
                this.manageModal = false
                this.form.clearErrors()
                this.form.reset()
            },

            showModal() {
                this.form.clearErrors()
                this.manageModal = true
            },

            showSearchModal () {
                this.searchModal = true
            },

            closeSearchModal() {
                this.searchModal = false
                this.form.clearErrors()
            },

            store() {
                this.form.post(route('users.store'), {
                    preserveScroll: true,
                })
            }
        }
    })
</script>
